export function getNomePerfil(perfil) {
  if (perfil === 'admin') return 'Administrador';
  if (perfil === 'supervisor') return 'Supervisor';
  if (perfil === 'atendente') return 'Atendente';
  return perfil || '';
}

export function getPermissoes(perfil) {
  return {
    podeVerNovoAtendimento: ['admin', 'supervisor', 'atendente'].includes(perfil),
    podeVerDashboard: ['admin', 'supervisor', 'atendente'].includes(perfil),
    podeVerPrestadores: ['admin', 'supervisor'].includes(perfil),
    podeVerHistorico: ['admin', 'supervisor'].includes(perfil),
    podeOperarAtendimento: ['admin', 'supervisor', 'atendente'].includes(perfil),
    podeGerenciarPrestadores: ['admin', 'supervisor'].includes(perfil),
    podeVerRelatorios: ['admin', 'supervisor'].includes(perfil),
    podeAdministrarUsuarios: ['admin'].includes(perfil),
    podeVerUsuarios: ['admin'].includes(perfil),
  };
}

export function getAbaInicialPermitida(permissoes) {
  if (permissoes.podeVerNovoAtendimento) return 'novo';
  if (permissoes.podeVerDashboard) return 'dashboard';
  if (permissoes.podeVerPrestadores) return 'prestadores';
  return 'historico';
}

export function getAbaAtualSegura(abaAtiva, permissoes) {
  const permitida =
    (abaAtiva === 'novo' && permissoes.podeVerNovoAtendimento) ||
    (abaAtiva === 'dashboard' && permissoes.podeVerDashboard) ||
    (abaAtiva === 'prestadores' && permissoes.podeVerPrestadores) ||
    (abaAtiva === 'historico' && permissoes.podeVerHistorico) ||
    (abaAtiva === 'usuarios' && permissoes.podeVerUsuarios);

  return permitida ? abaAtiva : getAbaInicialPermitida(permissoes);
}
